import { apiCall } from "./apiClient";
import {
    TransportOrderDetailsDto
} from "../models/transport/transportOrder";

export const getTransportOrderDetails = (
    params : { orderId: string },
    signal: AbortSignal
) => {
    return apiCall<TransportOrderDetailsDto>(
        `TransportOrders/${params.orderId}`,
        "GET",
        null,
        signal
    );
};
